import { __awaiter, __generator } from "tslib";
import { DevicePermissionStorageService, PermissionStatus, } from '@metaos/hub-sdk';
var AppHostDevicePermissionService = /** @class */ (function () {
    function AppHostDevicePermissionService(appId, userId, askForConsentCallback) {
        this.storageService = new DevicePermissionStorageService(appId, userId);
        this.askForConsentCallback = askForConsentCallback;
    }
    AppHostDevicePermissionService.prototype.requestUserConsentForPermission = function (permission) {
        return __awaiter(this, void 0, void 0, function () {
            var status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.storageService.getPermissionStatus(permission)];
                    case 1:
                        status = _a.sent();
                        if (!(status === PermissionStatus.NeverAsked)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.askForConsentCallback(permission)];
                    case 2:
                        status = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, Promise.resolve({
                            permission: permission,
                            status: status,
                        })];
                }
            });
        });
    };
    return AppHostDevicePermissionService;
}());
export { AppHostDevicePermissionService };
//# sourceMappingURL=AppHostDevicePermissionService.js.map